import request from './request'

//Para cada módulo crear un archivo con las requests necesarias, para exportarlas y llamarlas desde el componente correspondiente

export function getAllLotes(){
    return request({
        url:'/lotes/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getDetallesLote(idLote){
    return request({
        url:'/lotes/id/' + idLote,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function modificarDesierto(lote){
    return request({
        url:'/lotes/desierto/' + lote.id,
        method:'PUT',
        data: lote,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function modificarDesistido(lote){
    return request({
        url:'/lotes/desistir/' + lote.id,
        method:'PUT',
        data: lote,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function reordenarOfertas(lote, listaOfertas){
    return request({
        url:'/lotes/reordenarOfertas/' + lote.id,
        method:'PUT',
        data: listaOfertas,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}